import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import ApiService from "@/core/services/ApiService";
import { User } from "@/core/services/api/interfaces/manager/User";
import { FlexpspAccount } from "@/core/services/api/interfaces/manager/BankAccount";

@Module
export default class FlexpspModule extends VuexModule {
  accounts = [] as FlexpspAccount[];

  get hasFlexpspAccounts(): boolean {
    return this.accounts.length > 0;
  }

  @Action({ rawError: true })
  [Actions.MANAGER_PSP_PORTAL_ACCOUNTS_LOAD]() {
    return ApiService.manager.flexpsp
      .listAccounts()
      .then(ApiService.unwrapItemResponse<FlexpspAccount[]>)
      .then(async (data) => {
        this.context.commit(Mutations.MANAGER_PSP_PORTAL_ACCOUNTS_SET, data);

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_PSP_PORTAL_ACCOUNTS_LOAD
        );

        return data;
      });
  }
  @Action({ rawError: true })
  async [Actions.MANAGER_PSP_PORTAL_USER_SIGN_UP](form) {
    return ApiService.manager.flexpsp
      .registration(form)
      .then(ApiService.unwrapItemResponse<User>)
      .then((user) => {
        return this.context.commit(Mutations.COMMON_USER_SET, user);
      });
  }
  @Action({ rawError: true })
  async [Actions.MANAGER_PSP_PORTAL_USER_UPSERT_ACCOUNTS](data) {
    return ApiService.manager.flexpsp
      .upsertAccounts(data)
      .then(ApiService.unwrapItemResponse<FlexpspAccount[]>)
      .then((accounts) => {
        this.context.commit(
          Mutations.MANAGER_PSP_PORTAL_ACCOUNTS_SET,
          accounts
        );

        return accounts;
      });
  }
  @Action({ rawError: true })
  async [Actions.MANAGER_PSP_PORTAL_USER_REVOKE_TOKEN]() {
    return ApiService.manager.flexpsp
      .revokeToken()
      .then(ApiService.unwrapItemResponse<User>)
      .then((user) => {
        return this.context.commit(Mutations.COMMON_USER_SET, user);
      });
  }

  @Mutation
  [Mutations.MANAGER_PSP_PORTAL_ACCOUNTS_SET](accounts: FlexpspAccount[]) {
    this.accounts = accounts;
  }
}
